import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { ExternalRoutesGuard } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard extends ExternalRoutesGuard {

  protected redirect (activatedRouteSnapshot: ActivatedRouteSnapshot,
                      state: RouterStateSnapshot) {
    if (this.winRef.isBrowser() && this.winRef.nativeWindow) {
      this.winRef.nativeWindow.location.href = state?.url?.substring(state.url.indexOf('http')).replace(':/', '://')
    }
  }
}
